// extracted by mini-css-extract-plugin
export default {"iframe":"MetabaseAppDashboard_iframe__oRxBA"};